import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";

import magnifiAPI from "../../services/api/magnifi";
import { user } from "../schemas";

export const getSSOUrl = createAsyncThunk("magnifiUser/getSSOUrl", async (payload, { rejectWithValue }) => {
  try {
    const response = await magnifiAPI.getSSOUrl({ payload });

    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data ?? { message: "Something went wrong. Please try again." });
  }
});

export const loginUser = createAsyncThunk("magnifiUser/loginUser", async (payload, { rejectWithValue }) => {
  try {
    const response = await magnifiAPI.login({ payload });

    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data ?? { message: "Something went wrong. Please try again." });
  }
});

export const updateToken = createAsyncThunk("magnifiUser/updateToken", async (payload) => {
  try {
    const response = await magnifiAPI.updateToken({ payload });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createAccount = createAsyncThunk("magnifiUser/createAccount", async (payload, { rejectWithValue }) => {
  try {
    const response = await magnifiAPI.signup({ payload });

    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data ?? { message: "Something went wrong. Please try again." });
  }
});

export const registerGCPUser = createAsyncThunk("magnifiUser/registerGCPUser", async (payload, { rejectWithValue }) => {
  try {
    const response = await magnifiAPI.registerGCPUser({ payload });

    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data ?? { message: "Something went wrong. Please try again." });
  }
});

export const getMyProfile = createAsyncThunk("magnifiUser/getMyProfile", async (payload) => {
  try {
    const response = await magnifiAPI.getMyProfile(payload);

    return {
      ...response.data,
      ...(response.data.status ? normalize(response.data.data, user) : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getUsers = createAsyncThunk("magnifiUser/getUsers", async (payload) => {
  try {
    const response = await magnifiAPI.getUsers(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const removeIp = createAsyncThunk("magnifiUser/removeIp", async (payload) => {
  try {
    const response = await magnifiAPI.removeIp(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteUserProfile = createAsyncThunk("magnifiUser/deleteUserProfile", async (payload) => {
  try {
    const response = await magnifiAPI.deleteUserProfile(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const editUserProfile = createAsyncThunk("magnifiUser/editUserProfile", async (payload) => {
  try {
    const response = await magnifiAPI.editUserProfile(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createUserProfile = createAsyncThunk("magnifiUser/createUserProfile", async (payload) => {
  try {
    const response = await magnifiAPI.createUserProfile(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addSocialMediaPlatforms = createAsyncThunk("magnifiUser/addSocialMediaPlatforms", async (payload) => {
  try {
    const response = await magnifiAPI.addSocialMediaPlatforms(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const fetchBrightCoveToken = createAsyncThunk("magnifiUser/getBrightCoveToken", async (payload) => {
  try {
    const response = await magnifiAPI.getBrightCoveToken(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getBrightCoveUser = createAsyncThunk("magnifiUser/getBrightCoveUser", async (payload) => {
  try {
    const response = await magnifiAPI.getBrightCoveUser(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const fetchFolderListFromBrightCove = createAsyncThunk(
  `magnifiUser/fetchFolderListFromBrightCove`,
  async (payload) => {
    try {
      const response = await magnifiAPI.fetchFolderListFromBrightCove(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const fetchVideoUrlListFromBrightCove = createAsyncThunk(
  `magnifiUser/fetchVideoUrlListFromBrightCove`,
  async (payload) => {
    try {
      const response = await magnifiAPI.fetchVideoUrlListFromBrightCove(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const forgotPassword = createAsyncThunk("magnifiUser/forgotPassword", async (payload, { rejectWithValue }) => {
  try {
    const response = await magnifiAPI.forgotPassword({ payload });

    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data ?? { message: "Something went wrong. Please try again." });
  }
});

export const resetUserPassword = createAsyncThunk(
  "magnifiUser/resetUserPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await magnifiAPI.resetUserPassword(payload);

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data ?? { message: "Something went wrong. Please try again." });
    }
  },
);
